import { createFileRoute } from '@tanstack/react-router';
import KnowledgePage from '@/components/knowledge/KnowledgePage';
import { createManageRouteGuard } from '@/utils/manageRouteGuards';
import { TENANT_ROLES } from '@/constants/tenantRoles';

export const Route = createFileRoute('/manage/knowledge')({
  beforeLoad: createManageRouteGuard({ requiredTenantRoles: [TENANT_ROLES.OWNER] }),
  component: KnowledgePage
});
